@if (
  email.state !== EmailState.Draft &&
  email.state !== EmailState.SendError &&
  email.state !== EmailState.Sending
) {
  <div
    [ngClass]="archiveClass"
    class="flex h-full w-full cursor-default items-center justify-center">
    <span
      class="material-symbols-outlined"
      matTooltip="{{ archiveTooltip | translate }}">
      {{ archiveIcon }}
    </span>
  </div>
}
